import React from 'react';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';

const DeleteIcon = (props) => {
  return <Icon path={mdiClose} {...props} />;
};

export default DeleteIcon;
